import { parseData, post, parseDataPermissionException } from './common';
import { responseHandler } from '../api/api';
const checkInProgress = () => post('/InternalAPI/SingleStepImplementationAPI.asmx/CheckInProgress')
    .then(parseData)
    .then(responseHandler);
const getCurrentRequests = () => post('/InternalAPI/SingleStepImplementationAPI.asmx/GetCurrentRequests')
    .then(parseData)
    .then(responseHandler);
const getTemplate = () => post('/InternalAPI/SingleStepImplementationAPI.asmx/DownloadTemplate').then(parseData);
const validateFile = (fileEnc64) => post('/InternalAPI/SingleStepImplementationAPI.asmx/ValidateFile', {
    FileEnc64: fileEnc64
}).then(parseData);
const createSSIRequest = (fileEnc64) => post('/InternalAPI/SingleStepImplementationAPI.asmx/CreateSSIRequest', {
    FileEnc64: fileEnc64
}).then(parseData);
const getCurrentStep = () => post('/InternalAPI/SingleStepImplementationAPI.asmx/GetCurrentStep')
    .then(parseDataPermissionException)
    .then(responseHandler);
const setCurrentStep = (Type) => post('/InternalAPI/SingleStepImplementationAPI.asmx/SetCurrentStep', {
    Type
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const getSetupData = (Type) => post('/InternalAPI/SingleStepImplementationAPI.asmx/GetSetupData', {
    Type
}).then(parseDataPermissionException);
const getSpreadSheet = (Type, FormData) => post('/InternalAPI/SingleStepImplementationAPI.asmx/GetSpreadSheet', {
    Type,
    FormData
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const uploadSpreadSheet = (Type, FileEnc64) => post('/InternalAPI/SingleStepImplementationAPI.asmx/UploadSpreadSheet', {
    Type,
    FileEnc64
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const saveSetupData = (Type, Data = '', isFile = false) => post('/InternalAPI/SingleStepImplementationAPI.asmx/SaveSetupData', {
    Type,
    Data,
    isFile
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const saveFiltrationOfCategories = (FilterData) => post('/InternalAPI/SingleStepImplementationAPI.asmx/SaveFiltrationOfCategories', {
    FilterData
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const saveCompanyPolicy = (CompanyPolicy) => post('/InternalAPI/SingleStepImplementationAPI.asmx/SaveCompanyPolicy', {
    CompanyPolicy
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const getReviewCount = () => post('/InternalAPI/SingleStepImplementationAPI.asmx/GetReviewCount')
    .then(parseDataPermissionException)
    .then(responseHandler);
const mapUsersToEmpGLD = (lsEmpMappingData) => post('/InternalAPI/SingleStepImplementationAPI.asmx/MapUsersToEmpGLD', {
    lsEmpMappingData
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const uploadCompanyPolicyFile = (FileName, FileEnc64) => post('/InternalAPI/SingleStepImplementationAPI.asmx/UploadCompanyPolicyFile', {
    FileName,
    FileEnc64
})
    .then(parseDataPermissionException)
    .then(responseHandler);
const finishSetup = () => post('/InternalAPI/SingleStepImplementationAPI.asmx/FinishSetup')
    .then(parseDataPermissionException)
    .then(responseHandler);
const getStepStatus = (Type, Index = 0) => post('/InternalAPI/SingleStepImplementationAPI.asmx/GetStepStatus', {
    Type,
    Index
})
    .then(parseDataPermissionException)
    .then(responseHandler);
export { checkInProgress, getCurrentRequests, getTemplate, validateFile, createSSIRequest, getCurrentStep, setCurrentStep, getSetupData, getSpreadSheet, uploadSpreadSheet, saveSetupData, saveFiltrationOfCategories, saveCompanyPolicy, mapUsersToEmpGLD, getReviewCount, uploadCompanyPolicyFile, finishSetup, getStepStatus };
